/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

// Endpoints
export const fetchModelsEndpoint = "/HttpTriggerCoverageRequirements?request_operation=get&request_type=getModelsList"
export const fetchVersionsEndpoint = "/HttpTriggerCoverageRequirements?request_operation=get&request_type=getVersionsList"
export const fetchVariationsEndpoint = "/HttpTriggerCoverageRequirements?request_operation=get&request_type=getVariationsList"

// Error messages
export const fetchModelsError = "An error occurred while fetching the Models list"
export const fetchVersionsError = "An error occurred while fetching the Versions list"
export const fetchVariationsError = "An error occurred while fetching the Variations list"
